import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12a3c9f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2 flex-wrap gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-color-secondary"
}
const _hoisted_3 = { class: "flex flex-wrap gap-2 mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Period timeline", -1))
const _hoisted_6 = { class: "timeline" }
const _hoisted_7 = { class: "text-color-secondary" }
const _hoisted_8 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Charge breakdown", -1))
const _hoisted_10 = { class: "charge-bars" }
const _hoisted_11 = { class: "charge-name" }
const _hoisted_12 = { class: "bar-track" }
const _hoisted_13 = { class: "charge-val" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Period shortcuts" }),
      (_ctx.formulaSet)
        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createTextVNode(" Formulas v" + _toDisplayString(_ctx.formulaSet.version) + " · " + _toDisplayString(_ctx.formulaSet.checksum), 1)
          ])), [
            [
              _directive_tooltip,
              'Hardcoded tariff formula set fingerprint',
              void 0,
              { top: true }
            ]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.canGenerateInvoice)
        ? (_openBlock(), _createBlock(_component_PButton, {
            key: 0,
            disabled: !_ctx.billingPeriodId || _ctx.busy,
            loading: _ctx.busyKey === 'invoice',
            icon: "pi pi-file",
            label: "Generate invoice",
            outlined: "",
            rounded: "",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('generate-invoice')))
          }, null, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.canReports)
        ? (_openBlock(), _createBlock(_component_PButton, {
            key: 1,
            disabled: !_ctx.billingPeriodId || _ctx.busy,
            loading: _ctx.busyKey === 'invoice_package',
            icon: "pi pi-book",
            label: "Invoice package",
            outlined: "",
            rounded: "",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('report', 'invoice_package')))
          }, null, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.canReports)
        ? (_openBlock(), _createBlock(_component_PButton, {
            key: 2,
            disabled: !_ctx.billingPeriodId || _ctx.busy,
            loading: _ctx.busyKey === 'nee_export',
            icon: "pi pi-bolt",
            label: "NEE export",
            outlined: "",
            rounded: "",
            size: "small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('report', 'nee_export')))
          }, null, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.canReports)
        ? (_openBlock(), _createBlock(_component_PButton, {
            key: 3,
            disabled: !_ctx.billingPeriodId || _ctx.busy,
            loading: _ctx.busyKey === 'ppm',
            icon: "pi pi-chart-line",
            label: "PPM report",
            outlined: "",
            rounded: "",
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('report', 'ppm')))
          }, null, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.timeline?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeline, (ev, idx) => {
              return (_openBlock(), _createElementBlock("li", { key: idx }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(ev.at || '—'), 1),
                _createTextVNode(" — " + _toDisplayString(ev.label), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.chargeBreakdown?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chargeBreakdown, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.name,
                class: "charge-row"
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.shortName(item.name)), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "bar-fill",
                    style: _normalizeStyle({ width: _ctx.barWidth(item.value) })
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.fmt(item.value)), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}